import { render, staticRenderFns } from "./ApplicationsComponent.vue?vue&type=template&id=67914895"
import script from "./ApplicationsComponent.vue?vue&type=script&lang=js"
export * from "./ApplicationsComponent.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsComponent.vue?vue&type=style&index=0&id=67914895&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports